import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfaComponent } from './pdfa.component';
import { MatCardModule } from "@angular/material/card";
import { RouterModule } from '@angular/router';
import { PdfaRoutingModule } from './pdfa-routing.module';
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";



@NgModule({
  declarations: [
    PdfaComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    RouterModule,
    PdfaRoutingModule,
    NgxUiLoaderModule,
    MatProgressSpinnerModule
]
})
export class PdfaModule { }
